"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgRevokeAuthorization = void 0;
var json_1 = require("../../../util/json");
var MsgRevokeAuthorization = /** @class */ (function (_super) {
    __extends(MsgRevokeAuthorization, _super);
    /**
     * @param granter authorization granter
     * @param grantee authorization grantee
     * @param authorization_msg_type type of message to revoke
     */
    function MsgRevokeAuthorization(granter, grantee, msg_type_url) {
        var _this = _super.call(this) || this;
        _this.granter = granter;
        _this.grantee = grantee;
        _this.msg_type_url = msg_type_url;
        return _this;
    }
    MsgRevokeAuthorization.fromData = function (data) {
        var _a = data.value, granter = _a.granter, grantee = _a.grantee, msg_type_url = _a.msg_type_url;
        return new MsgRevokeAuthorization(granter, grantee, msg_type_url);
    };
    MsgRevokeAuthorization.prototype.toData = function () {
        var _a = this, granter = _a.granter, grantee = _a.grantee, msg_type_url = _a.msg_type_url;
        return {
            type: 'msgauth/MsgRevokeAuthorization',
            value: {
                granter: granter,
                grantee: grantee,
                msg_type_url: msg_type_url,
            },
        };
    };
    return MsgRevokeAuthorization;
}(json_1.JSONSerializable));
exports.MsgRevokeAuthorization = MsgRevokeAuthorization;
//# sourceMappingURL=MsgRevokeAuthorization.js.map